import { useTexts } from 'components/texts';
import { HeadingRow } from 'components/design/grid';
import { Link } from 'react-router';
import { Breadcrumb } from 'components/breadcrumb';

const RouteErrorBoundary = () => {
  const T = useTexts();

  return (
    <>
      <Breadcrumb />
      <HeadingRow tag="h1" valign="center" content={T.SomethingWentWrong} />
      <p className="text-danger">{T.SomethingWentWrongDescription}</p>
      <Link to="/">{T.BackToWorkflows}</Link>
    </>
  );
};

export default RouteErrorBoundary;
